// Environment configuration
// Single source of truth for all API and Socket URLs

// Base URLs - use VITE_API_URL from .env file
const API_URL = import.meta.env.VITE_API_URL || '';

// Determine if we're in production based on the URL
const isProduction = API_URL.includes('entropia-1058627764168') || API_URL.includes('entropia-seven.vercel.app');

export const ENV = {
  // Environment determination
  IS_PRODUCTION: isProduction,
  IS_DEVELOPMENT: !isProduction,
  
  // API Base URL - from .env file
  API_BASE_URL: API_URL,
  
  // Socket URL - same as API
  SOCKET_URL: API_URL,
  
  // Frontend URL - determined by API URL
  FRONTEND_URL: import.meta.env.VITE_FRONTEND_URL || (isProduction ? API_URL : 'http://localhost:3000'),
  
  // Environment name for logging
  ENV_NAME: isProduction ? 'production' : 'development',
  
  // Debug mode - from .env or development mode
  DEBUG: !isProduction || import.meta.env.VITE_ENABLE_LOGGING === 'true'
};

// Helper functions for consistent API endpoint building
export const getApiUrl = (endpoint: string): string => {
  const baseUrl = ENV.API_BASE_URL;
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${baseUrl}${cleanEndpoint}`;
};

export const getSocketUrl = (): string => {
  return ENV.SOCKET_URL;
};

// Debug helpers that respect NODE_ENV
export const debugLog = (...args: unknown[]): void => {
  if (ENV.DEBUG || process.env.NODE_ENV === 'development') {
    console.log(...args);
  }
};

export const debugError = (...args: unknown[]): void => {
  if (ENV.DEBUG || process.env.NODE_ENV === 'development') {
    console.error(...args);
  }
};

// Export for use in components
export default ENV;